/* Tysk katalog for locale-registry-control.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'control.example': 'Erstelle eine Rechnung, lege einen Lieferanten an oder ändere die E-Mail-Adresse eines Kunden …',
  'registry.customer': 'Kunden',
  'registry.supplier': 'Lieferanten',
  'registry.product': 'Produkte',
  'registry.description': 'Beschreibung',
  'registry.price': 'Einzelpreis ohne MwSt.',
  'registry.type': 'Typ',
  'registry.vat': 'MwSt.-Behandlung',
  'registry.sku': 'SKU',
  'registry.ean': 'EAN/GTIN',
  'registry.group': 'Produktgruppe',
  'registry.goods': 'Ware',
  'registry.service': 'Dienstleistung',
  'registry.choose': 'Wählen …',
  'registry.newDraft': 'Neuer Eintrag – nicht gespeichert',
  'registry.selected': 'Ausgewählt: {name}',
  'registry.archivedLabel': 'Archiviert',
  'registry.matches': '{count} Treffer. {shown} werden angezeigt. Präzisiere die Suche, wenn mehrere passen.',
  'registry.working': 'Arbeite im Register …',
  'registry.review': 'Prüfe die Angaben im Registerbereich.',
  'registry.done.observed': 'Das Register ist geöffnet und die Treffer werden angezeigt.',
  'registry.done.opened': 'Der Registereintrag ist geöffnet.',
  'registry.repeatedRead': 'Dieselbe Registerabfrage wurde bereits ausgeführt. Prüfe die angezeigten Treffer, bevor du fortfährst.',
  'registry.done.applied': 'Die Felder sind ausgefüllt. Die Änderungen sind noch nicht gespeichert.',
  'registry.done.saved': 'Der Registereintrag ist gespeichert.',
  'registry.done.archived': 'Der Registereintrag ist archiviert.',
  'registry.done.restored': 'Der Lieferant ist wieder aktiv.',
  'registry.done.unchanged': 'Keine neuen Änderungen zu speichern.',
  'registry.changed': 'Der Eintrag wurde seit dem Öffnen geändert. Schließe den Registerbereich und bitte mich, ihn neu zu laden.',
  'registry.selectFirst': 'Suche zuerst den richtigen Registereintrag und wähle ihn aus.',
  'registry.unsupportedField': 'Dieses Feld wird hier nicht unterstützt. Verwende das normale Formular auf der Seite.',
  'registry.unsupported': 'Diese Aktion muss im normalen Formular auf der Seite ausgeführt werden.',
  'registry.advancedProduct': 'Änderungen an MwSt./Typ, Abonnements und Vermietung müssen im normalen Produktformular vorgenommen werden.',
  'registry.archived': 'Der Eintrag ist archiviert und kann hier nicht bearbeitet werden.',
  'registry.authorization': 'Beschreibe ausdrücklich, was du speichern, archivieren oder wieder öffnen möchtest.',
  'registry.country': 'Automatisches Speichern im Register wird derzeit für norwegische Unternehmen unterstützt. Verwende für dieses Unternehmen das normale Formular.',
  'registry.uncertain': 'Das Speichern wurde nicht bestätigt. Prüfe den Eintrag auf der Seite, bevor du es erneut versuchst.',
  'registry.unsaved': 'Im Registerbereich gibt es ungespeicherte Änderungen. Speichere sie oder schließe zuerst den Bereich.',
  'registry.duplicate': 'Ein anderer Eintrag hat denselben Namen oder dieselbe Organisationsnummer. Schließe den Bereich und wähle den richtigen vorhandenen Eintrag, oder verwende das normale Formular.',
});
